import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// Import all namespace files
import billing from '@/locales/en/billing.json';
import common from '@/locales/en/common.json';
import dashboard from '@/locales/en/dashboard.json';
import inbound from '@/locales/en/inbound.json';
import navigation from '@/locales/en/navigation.json';
import outbound from '@/locales/en/outbound.json';
import pagination from '@/locales/en/pagination.json';
import stock from '@/locales/en/stock.json';
import table from '@/locales/en/table.json';
import createInbound from '@/locales/en/createInbound.json';
import createOutbound from '@/locales/en/createOutbound.json';
import userProfile from '@/locales/en/userProfile.json';
import roadTransport from '@/locales/en/roadTransport.json';
import createRoadTransport from '@/locales/en/createRoadTransport.json';
import shipmentCreation from '@/locales/en/shipmentCreation.json';
import admin from '@/locales/en/admin.json';
import relations from '@/locales/en/relations.json';
import announcements from '@/locales/en/announcements.json';
import containers from '@/locales/en/containers.json';

/**
 * i18next configuration
 * 
 * Uses hardcoded 'en' locale since only English is supported.
 * Future multi-language support can detect locale from:
 * - Browser navigator.language
 * - User preference in localStorage
 * - Backend user profile
 */
i18n.use(initReactI18next).init({
  lng: 'en',
  fallbackLng: 'en',
  
  resources: {
    en: {
      billing,
      common,
      dashboard,
      inbound,
      navigation,
      outbound,
      pagination,
      stock,
      table,
      createInbound,
      createOutbound,
      userProfile,
      roadTransport,
      createRoadTransport,
      shipmentCreation,
      admin,
      relations,
      announcements,
      containers,
    },
  },

  interpolation: {
    escapeValue: false, // React already escapes values
    // Use single curly braces to match next-intl format from original translation files
    prefix: '{',
    suffix: '}',
  },

  // Enable debug in development
  debug: import.meta.env.DEV,
});

export default i18n;

// Re-export commonly used types
export type { TFunction } from 'i18next';
